import { MainConfig }  from './mainconfig';
import { features } from './features';

import { 
    language,
    dateStyle
} from './language';

import { 
    countries,
    default_country_code
} from './countries';

const AppDetails = MainConfig.AppDetails;
const FirebaseConfig = MainConfig.FirebaseConfig;
const Google_Map_API_Key = MainConfig.Google_Map_API_Key;
const facebookAppId = MainConfig.facebookAppId;
const PurchaseDetails = MainConfig.PurchaseDetails;

const mainUrl = "cloudfunctions.net";
const cloud_function_server_url = `https://us-central1-${FirebaseConfig.projectId}.${mainUrl}`;
const paypal_client_id = 'AWY1kHyhdEBA64gq_QqyIVw-vY3IqZxYqiARja_GFEhiK4TnrvtmrbZ0YVXf-MX30QiTcKYh6yMu2Vhu';
const stripe = 'pk_test_51HOjd4EVxgKyjeNwJHzyp5MtYEfmWTu7ZSwcFh7TIecpu7jbQ1gekqbTVIoQi8zYsVnbNL52llWTMQcrpBdUz1f000FdDDzWCT';
const stripe_public_key = 'sk_test_51HOjd4EVxgKyjeNwHPpqyFgNdV1MQ7fE4JOiJ3UvzoxWeMT7ZLxS5PImknDaiWWe16UX0HX9c8hfv6ErD4K3eZMS009qro6z1X';

export {
    AppDetails,
    language,
    FirebaseConfig,
    Google_Map_API_Key,
    PurchaseDetails,
    dateStyle,
    facebookAppId,
    cloud_function_server_url,
    features,
    countries,
    default_country_code,
    mainUrl,
    paypal_client_id,
    stripe,
    stripe_public_key
}